export default "__VITE_ASSET__9q4niLSK__"